import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPrevArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 27,
	height: 18,
	viewBox: "0 0 27 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.6155 1.0652L0.496014 8.13706C-0.165418 8.52301 -0.165319 9.47878 0.496199 9.86459L12.6162 16.9333C13.1206 17.2275 13.6342 16.566 13.2241 16.1503L7.55757 10.405C7.43503 10.2808 7.33204 10.1445 7.2486 10L25.0055 10C25.5578 10 26.0055 9.5523 26.0055 9.00002C26.0055 8.44773 25.5578 8.00002 25.0055 8.00002L7.24925 8.00002C7.33248 7.85613 7.43512 7.72038 7.55717 7.59657L13.2236 1.84806C13.6335 1.43223 13.1199 0.770926 12.6155 1.0652Z",
		fill: "#004899"
	})
});
export default SvgIconPrevArrow;
